// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"user-talk-off-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.4721 7.4724C12.4904 7.31747 12.4997 7.15983 12.4997 7C12.4997 4.79086 10.7089 3 8.49974 3C8.33991 3 8.18227 3.00937 8.02734 3.0276M17.1699 11.2468C17.3878 10.8679 17.5025 10.4385 17.5027 10.0014C17.5028 9.56437 17.3884 9.1349 17.1708 8.75586M20.2041 12.9919C20.727 12.0826 21.0024 11.052 21.0027 10.0031C21.0031 8.9541 20.7284 7.92338 20.2062 7.01367M16 20V19C16 16.7909 14.2091 15 12 15H5C2.79086 15 1 16.7909 1 19V20M10.4777 10.4778C9.89441 10.8102 9.21938 11.0001 8.5 11.0001C6.29086 11.0001 4.5 9.20928 4.5 7.00015C4.5 6.28076 4.6899 5.60574 5.02232 5.02246L10.4777 10.4778Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21 21L3 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UserTalkOff1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-talk-off-1',
    ref,
    icon: element,
  },
));

UserTalkOff1Icon.displayName = 'UserTalkOff1Icon';

export default UserTalkOff1Icon;
